import {
  API_HOST,
  API_IMG_HOST,
  API_HOST_JAVA_SET
} from './local.js'
import Qs from 'qs'
import axios from 'axios'
import Lockr from 'lockr'
// import Vueaxios from 'vue-axiosp'
const axiosPhp = axios.create({
  baseURL: API_HOST
})
// axiosPhp.defaults.baseURL = API_HOST
axiosPhp.defaults.timeout = 1000 * 15
axiosPhp.defaults.headers.authKey = Lockr.get('authKey')
axiosPhp.defaults.headers.sessionId = Lockr.get('sessionId')
axiosPhp.defaults.headers['Content-Type'] = 'application/json'
axiosPhp.defaults.paramsSerializer = function (params) {
  return Qs.stringify(params)
}

let pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
      if (config.method == 'post' || config.method == 'put') {
        pending[p].f('cancel') // 执行取消操作
        pending.splice(p, 1) // 把这条记录从数组中移除
      }
    }
  }
}

// 返回处理
axiosPhp.interceptors.response.use(function (response) {
  removePending(response) // 在一个ajax发送前执行一下取消操作
  if (response.data.code == 101) {
    // 清空登录信息
    Lockr.rm('authKey')
    Lockr.rm('sessionId')
    Lockr.rm('userInfo')
    Lockr.rm('firstRoutePath')
    // // 跳转到登录页
    // router.push({path: '/login'})
    return response
  } else if (response.data.code > 101) {
    //_g.toastMsg('error', response.data.error)
    return response
  } else {
    return response
  }
}, function (error) {
  return Promise.reject(error)
})
// 添加请求拦截器
axiosPhp.interceptors.request.use(config => {
  removePending(config) // 在一个ajax发送前执行一下取消操作
  config.cancelToken = new CancelToken((c) => {
    // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
    pending.push({
      u: config.url + '&' + config.method,
      f: c
    })
  })
  return config
}, error => {
  return Promise.reject(error)
})

// 等级管理-列表
export function getYzGrade (page, search) {
  let url = 'yunzhong/yzgrade'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}

// 会员等级列表 删除
export function deleteYzGrade (id) {
  let url = 'yunzhong/yzgrade/' + id
  return axiosPhp.delete(url, {
    params: {
      id: id
    }
  })
}

// 创建会员等级
export function createYzGrade (data) {
  let url = 'yunzhong/yzgrade'
  return axiosPhp.post(url, data)
}
// 会员等级详情
export function getYzGradeDetail (id) {
  let url = 'yunzhong/yzgrade/' + id
  return axiosPhp.get(url)
}
// 编辑会员等级
export function editYzGrade (id, data) {
  let url = 'yunzhong/yzgrade/' + id
  return axiosPhp.put(url, data)
}

// 积分兑换管理-列表
export function getYzIntegralSet (page, search) {
  let url = 'yunzhong/yzintegralset'
  return axiosPhp.get(url, {
    params: {
      limit: 10,
      page: page,
      search: search
    }
  })
}
// 积分兑换列表 删除
export function deleteYzIntegralSet (id) {
  let url = 'yunzhong/yzintegralset/' + id
  return axiosPhp.delete(url, {
    params: {
      id: id
    }
  })
}
// 创建积分兑换
export function createYzIntegralSet (data) {
  let url = 'yunzhong/yzintegralset'
  return axiosPhp.post(url, data)
}
// 积分兑换详情
export function getYzIntegralSetDetail (id) {
  let url = 'yunzhong/yzintegralset/' + id
  return axiosPhp.get(url)
}
// 编辑积分兑换
export function editYzIntegralSet (id, data) {
  let url = 'yunzhong/yzintegralset/' + id
  return axiosPhp.put(url, data)
}